import { AppBar, IconButton, TextField, Typography, styled } from '@mui/material';

export const StyledAppBar = styled(AppBar)({
  position: 'relative',
  backgroundColor: '#29064C',
  height: '330px',
});

export const StyledIconButton = styled(IconButton)({
  color: 'white',
});

export const UserProfileTitle = styled(Typography)({
  color: 'white',
  fontSize: '1.3rem',
});

export const UserName = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontSize: '1.9rem',
  marginTop: theme.spacing(1),
}));

export const UserNameEdit = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    color: theme.palette.common.white,
    fontSize: '3rem',
    textAlign: 'center',
    padding: theme.spacing(0.5, 0, 0.5, 0),
  },
  '& .MuiInput-underline': {
    '&:before': {
      borderBottom: `1px solid ${theme.palette.common.white}`,
      transition: 'none',
    },
    '&:after': {
      borderBottom: `1px solid ${theme.palette.common.white}`,
      transition: 'none',
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: `1px solid ${theme.palette.common.white}`,
    },
    '&.Mui-error:after': {
      borderBottom: '1px solid #c40000',
    },
  },
}));
